import styled from 'styled-components';

/**
 * Testata della sezione package del selettore: package sopra, gruppo sotto.
 * La usano sia la modale, dove sono due Select, sia il drawer, dove sono due scritte:
 * il gruppo qualifica il package, quindi sta sotto e non accanto.
 */
export const PackageTargetHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    min-width: 0;

    /* I nomi lunghi si troncano invece di allargare la riga: flex:1 e min-width:0
       servono a far stringere il testo dentro la riga flex, l'ellipsis da sola non basta. */
    .package-target-name {
        flex: 1;
        min-width: 0;
        font-size: 0.85rem;
        font-weight: 600;
        text-transform: uppercase;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .package-target-empty {
        font-size: 0.8rem;
        font-style: italic;
        color: ${(props) => props.theme.TextColorMuted};
    }

    .package-target-row {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        min-width: 0;
    }

    /* I package si scelgono a vista invece che da una dropdown: sono pochi e vale la
       pena vederli tutti insieme con quanti book della modella hanno già dentro. */
    .package-target-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
        flex: 1;
        min-width: 0;
        /* con molti package attivi la fascia di chip non si mangia il pannello */
        max-height: 6rem;
        overflow-y: auto;

        /* Il chip è una riga: a cedere è il nome, il badge resta intero. */
        .ant-btn {
            max-width: 14rem;
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            overflow: hidden;

            > * {
                flex: none;
            }
        }

        .ant-btn > .package-chip-name {
            flex: 0 1 auto;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        /* Il badge sta dentro NwObjectCounter, che è un inline-block: lì si appoggia alla
           baseline e il box resta più alto di lui, così il chip centra il box e non il
           badge. Senza line box il contenitore aderisce al badge e il centraggio è vero. */
        .ant-btn .ant-badge {
            display: block;
            line-height: 1;
        }

        .ant-btn .ant-badge-count {
            position: static;
            top: auto;
            transform: none;
        }

        /* Sul chip attivo un badge blu sparirebbe sul blu: si inverte. Serve !important
           perché NwObjectCounter colora il badge con uno style inline. */
        .ant-btn-primary .ant-badge-count {
            background-color: #fff !important;
            color: ${(props) => props.theme.PrimaryColor} !important;
            box-shadow: none !important;
        }
    }

    .package-target-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        min-width: 0;
        color: ${(props) => props.theme.TextColorMuted};
        font-size: 0.8rem;
        text-transform: uppercase;
    }

    .package-target-group-name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${(props) => props.theme.TextColorMuted};
        font-size: 0.8rem;
        text-transform: uppercase;
    }

    /* Nel drawer package e gruppo non si scelgono: stanno sulla stessa riga, separati
       dal bullet. A stringersi sono i due nomi, non bullet e icona. */
    .package-target-fixed {
        display: flex;
        align-items: center;
        min-width: 0;

        > * {
            flex: none;
        }

        > .package-target-name,
        > .package-target-group-name {
            flex: 0 1 auto;
        }
    }
`;

export default PackageTargetHeader;
